import PropTypes from 'prop-types'
import { TabPane } from 'react-bootstrap'

const TabListSection = ({ children, condition, eventKey }) => (
  <TabPane eventKey={eventKey} id={`scroll-target-${eventKey}`} tabIndex="0">
    <If condition={condition}>
      {children}
    </If>
  </TabPane>
)

export default TabListSection

TabListSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]).isRequired,
  condition: PropTypes.bool.isRequired,
  eventKey: PropTypes.string.isRequired
}
